module.exports = __webpack_public_path__ + "img/107.28bc2a29.jpg";